<script lang="ts">
    import ProductReviewCard from "../elements/ProductReviewCard.svelte"
    import ReviewStars from "../elements/ReviewStars.svelte"
    import G2Logo from '$lib/assets/g2_reviews.png'
    import Link from "../elements/Link.svelte";

    export let reviews
    export let generalReview : {rating_copy: string, rating_stars: any[]}

</script>


<div class="product-reviews">
    <div class="product-reviews__review">
        <h3 class="product-reviews__review-heading">Excellent!</h3>
        <ReviewStars stars={generalReview.rating_stars}/>
        <div class="product-reviews__g2">
            <img src={G2Logo} alt="G2 reviews logo"/>
            <div class="product-reviews__g2__content">
                <h4>Based on G2 reviews</h4>
                <Link linkText="View more" link="https://www.g2.com/products/offerzen/reviews" showArrow={true}/>
            </div>
        </div>
    </div>
    <div class="product-reviews__user-reviews">
        {#each reviews as review }
            <ProductReviewCard 
                heading={review.heading} 
                author={review.author} 
                content={review.content}
                stars={review.stars}
                reviewLink={review.link}
            />
        {/each}
    </div>
</div>


<style lang="postcss">

    @import '../../styles/_mixins.css';
    .product-reviews {
        display: flex;
        max-width: 1200px;
        gap:60px;
        padding:10px 0;

        @mixin screen-lg {
            padding: 0 80px 120px;
        }

        @mixin screen-md {
            flex-direction:column;
            padding: 0 60px 0px;
        }

        @mixin screen-sm {
            padding:60px 24px;
        }

        & .product-reviews__review {
            & .product-reviews__review-heading {
                font-size:34px;
                color:var(--color_offerzen_navy);
                margin:0 0 16px;
            }

            & .product-reviews__g2 {

                display:flex;
                align-items: center;
                gap:16px;
                margin-top:16px;
                & img {
                    height:35px;
                }

                & .product-reviews__g2__content {
                    display: flex;
                    flex-direction: column;
                 
                    & h4 {
                        font-size:18px;
                        color:var(--color_offerzen_navy);
                        margin:0 0 6px;
                    }
                }
            }
        }

        & .product-reviews__user-reviews {
            display: flex;
            max-width:890px;
            gap:24px;

            @mixin screen-md {
                flex-direction:column;
            }
        }

    }
</style>